module.exports = __webpack_public_path__ + "media/packs/images/flags/GH-2e36f1c3771d8378849cf4848fff18a4.png";